import React, { useContext } from 'react';
import Announcement from './Announcement';
import firebase from 'firebase/app';
import 'firebase/firestore';
import { GenericAuthContext } from '@src/authContexts';
import { ErrorIndicator } from '@components/common/Error';
import { LoadingIndicatorLarge } from '@components/common/Loading';
import { AnnouncementData } from '@ypp-portal/models/announcement/announcementData';
import { useCollection } from 'react-firebase-hooks/firestore';
import { Role } from '@ypp-portal/models/user/role';

const AnnouncementStream: React.FC = () => {
  const { idToken, user } = useContext(GenericAuthContext);

  const baseCollection = firebase
    .firestore()
    .collection('announcements')
    .orderBy('created', 'asc')
    .limit(3);

  const roleQueryObject =
    idToken.claims.role === Role.Admin
      ? { role: Role.Admin, subrole: idToken.claims.subrole }
      : { role: idToken.claims.role };

  const forRole = baseCollection.where('forRoles', 'array-contains', roleQueryObject);
  const forUser = baseCollection.where('forUsers', 'array-contains', user.uid);

  const [forRoleCollection, forRoleLoading, forRoleError] = useCollection(forRole);
  const [forUserCollection, forUserLoading, forUserError] = useCollection(forUser);

  if (forRoleLoading || forUserLoading) {
    return <LoadingIndicatorLarge></LoadingIndicatorLarge>;
  }

  if (forRoleError || forUserError) {
    return <ErrorIndicator></ErrorIndicator>;
  }

  if (!forRoleCollection || !forUserCollection) {
    return <LoadingIndicatorLarge></LoadingIndicatorLarge>;
  }

  const forRoleWithId = forRoleCollection.docs.map((doc) => ({
    id: doc.id,
    data: doc.data() as AnnouncementData,
  }));
  const forUserWithId = forUserCollection.docs.map((doc) => ({
    id: doc.id,
    data: doc.data() as AnnouncementData,
  }));

  const data = forRoleWithId.concat(forUserWithId).sort((a, b) => {
    if (a.data.created < b.data.created) {
      return 1;
    }
    if (a.data.created > b.data.created) {
      return -1;
    }
    return 0;
  });

  return (
    <>
      <p className='font-raleway text-deepspace font-bold text-4xl mb-4 text-center'>
        NEWEST UPDATE
      </p>
      {data[0] ? (
        <Announcement id={data[0].id} announcement={data[0].data} />
      ) : (
        <p className='text-3xl text-deepspace text-center'>No Updates</p>
      )}
      <p className='font-raleway text-deepspace font-bold text-4xl mt-8 mb-4 text-center'>
        OLDER UPDATES
      </p>
      {data.slice(1, undefined).map((v) => (
        <Announcement key={v.id} id={v.id} announcement={v.data} />
      ))}
    </>
  );
};

export default AnnouncementStream;
